import { createContext } from 'react';

import { ClientId } from './types';

export const ClientOverrideContext = createContext<ClientId | null>(null);
